import React, { Children } from "react";
import { withStyles, Breadcrumbs, Typography } from "@material-ui/core";

const StyledBreadcrumbs = withStyles((theme) => ({
  separator: {
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(0.5),
    },
  },
  // ol: {
  //   "& > :last-child > *": {
  //     [theme.breakpoints.down("sm")]: {
  //       ...theme.typography.body1,
  //     },
  //   },
  // },
  root: {
    [theme.breakpoints.down("sm")]: {
      "& *": {
        lineHeight: "2rem",
      },
    },
  },
}))(Breadcrumbs);

export default function DashboardBreadcrumbs({ children }) {
  return (
    <StyledBreadcrumbs aria-label="breadcrumb">
      {Children.map(children, (e, idx) => (
        <Typography key={idx} variant="h5">
          {e}
        </Typography>
      ))}
    </StyledBreadcrumbs>
  );
}
